<template>
  <div>
    <div class="action-lists">
      <div class="left-btns">
        <div class="selected">推广计划</div>
        <div class="" @click="showOther('group')">推广组</div>
        <div class="" @click="showOther('adv')">创意</div>
      </div>
      <!-- <div class="right-action">
        <div class="" title="添加计划" @click="add()"><img src="../../../assets/images/add-icon.png" alt="添加计划"></div>
        <div class="" title="启用计划" @click="changeStatus(1)"><img src="../../../assets/images/start-icon.png" alt="启用计划"></div>
        <div class="" title="暂停计划" @click="changeStatus(0)"><img src="../../../assets/images/stop-icon.png" alt="暂停计划"></div>
        <div class="" title="删除计划" @click="del()"><img src="../../../assets/images/del-icon.png" alt="删除计划"></div>
        <el-input placeholder="搜索相关内容" v-model="keyword" class="input-with-select" style="width: 200px; margin-right: 20px;">
            <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
          </el-input>
      </div> -->
    </div>
    <div class="table">
      <div class="btns">
        <el-button type="primary" icon="fa fa-plus-circle" @click="add()"> 新建推广计划</el-button>
        <div class="make">
          <el-button size="small" @click="changeStatus(1)">开启</el-button>
          <el-button size="small" @click="changeStatus(0)">暂停</el-button>
          <el-button size="small" @click="del()">删除</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: 100%" @select="selectRow" @select-all="selectAll">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="计划名称">
            <template slot-scope="scope">{{ scope.row.title }}</template>
          </el-table-column>
          <el-table-column prop="name" label="投放日期">
            <template slot-scope="scope">
              {{ scope.row.end_time_type==1 ? scope.row.start_time +' 至 '+ scope.row.end_time : '不限'}}
            </template>
          </el-table-column>
          <el-table-column label="投放状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" @change="changeStatusOne(scope.$index)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="投放方式" show-overflow-tooltip>
            <template>网站访问</template>
          </el-table-column>
          <el-table-column prop="budget_title" label="总预算(元)" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button size="mini" @click="edit(scope.$index)">编辑</el-button>
              <el-button type="danger" size="mini" @click="delOne(scope.row.plan_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <div class="page-c">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>

    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="620px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="推广计划名称" prop="title">
          <el-input v-model="form.title" style="width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="投放目的" prop="purpose">
            <el-radio-group v-model="form.purpose">
                <el-radio v-model="form.purpose" label="1">网站访问</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="" style="width: 240px;">
                <el-option label="启用" value="1"></el-option>
                <el-option label="暂停" value="0"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="地域" prop="city">
            <el-cascader :options="options" :props="props" v-model="form.city" clearable collapse-tags style="width: 240px;"></el-cascader>
        </el-form-item>
        <el-form-item label="年龄" prop="checkboxGroup1">
            <el-checkbox-group v-model="form.checkboxGroup1" size="medium">
                <el-checkbox-button v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox-button>
            </el-checkbox-group>
        </el-form-item>
       <!-- <el-form-item label="开始时间">
          <el-date-picker v-model="form.start_time" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-radio-group v-model="form.end_time_type">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">指定日期</el-radio>
            <el-date-picker v-model="form.end_time" type="date" placeholder="选择日期" v-show="form.end_time_type > 0"></el-date-picker>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="总预算">
          <el-input v-model="form.budget" style="width: 160px;"></el-input>
          <span style="margin-left: 10px;">元不填写预算代表预算不限</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import options from '../../../plugin/city_code.js';
export default {
  name: 'index',
  data() {
    return {
      keyword: '',
      dialogFormVisible: false,
      title: '添加推广计划',
      tableData: [],
      props: { multiple: true, children: 'city', value: 'code', label: 'name' },
      cities: ['不限', '18-23', '24-30', '31-40', '41-49', '50+'],
      options: options,
      form: {
        plan_id: 0,
        title: '',
        budget: '',
        start_time: '',
        end_time_type: 0,
        end_time: '',
        purpose: '1',
        status: '1',
        checkboxGroup1: [],
        city: []
      },
      rules: {
        title: [
          { required: true, message: '请输入推广计划', trigger: 'blur' },
          { min: 0, max: 30, message: '长度不能超过30个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        city: [
          { type: 'array', required: true, message: '请选择地域', trigger: 'blur' }
        ],
        checkboxGroup1: [
          { type: 'array', required: true, message: '请至少选择一个年龄', trigger: 'change' }
        ],
        purpose: [
          { required: true, message: '请选择目的', trigger: 'change' }
        ]
      },
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      loading: true,
      ids: [],
      type: 'add'
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http.post('/trader/index/getPlanLists', {
        keyword: this.keyword,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    add() {
      this.dialogFormVisible = true;
      this.type = 'add';
      this.title = '添加推广计划';
    },
    selectRow(sel, row) {
      const selected = sel.length && sel.indexOf(row) !== -1;
      if (selected) {
        if (this.ids.indexOf(row.plan_id) === -1) {
          this.ids.push(row.plan_id);
        }
      } else {
        if (this.ids.indexOf(row.plan_id) !== -1) {
          this.ids.splice(this.ids.indexOf(row.plan_id), 1);
        }
      }
    },
    selectAll(sel) {
      if (sel.length > 0) {
        this.ids = [];
        for (var i = 0; i < sel.length; i++) {
          this.ids.push(sel[i].plan_id);
        }
      } else {
        this.ids = [];
      }
    },
    showOther(type) {
      this.$emit('showOther', type);
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    changeStatusOne(index) {
      this.ids.push(this.tableData[index].plan_id);
      this.changeStatus(this.tableData[index].status ? 1 : 0);
    },
    changeStatus(val) {
      if (this.ids.length) {
        this.$http.post('/trader/index/changePlanStatus', {
          ids: this.ids.join(','),
          value: val
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功，仅审核通过的创意可修改状态');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    edit(index) {
      this.type = 'edit';
      this.title = '编辑推广计划';
      this.form = {
        plan_id: this.tableData[index].plan_id,
        title: this.tableData[index].title,
        budget: parseFloat(this.tableData[index].budget_title) > 0 ? this.tableData[index].budget : '',
        start_time: this.tableData[index].start_time !== '0000-00-00 00:00:00' ? this.tableData[index].start_time : '',
        end_time_type: this.tableData[index].end_time_type,
        end_time: this.tableData[index].end_time !== '0000-00-00 00:00:00' ? this.tableData[index].end_time : '',
        purpose: '1',
        status: this.tableData[index].status ? '1' : '0',
        checkboxGroup1: [],
        city: []
      };
      this.dialogFormVisible = true;
    },
    delOne(id) {
      this.ids.push(id);
      this.del();
    },
    del() {
      if (this.ids.length) {
        this.$http.post('/trader/index/delPlan', {
          ids: this.ids.join(',')
        }).then(res => {
          if (res.code === 200) {
            this.getData();
            this.ids = [];
            this.$message.success('操作成功');
          } else {
            this.$message.error('操作失败');
          }
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.type === 'add' ? '/trader/index/createPlan' : '/trader/index/savePlan';
          this.$http.post(url, this.form).then(res => {
            if (res.code === 200) {
              this.page = 1;
              this.getData();
              this.dialogFormVisible = false;
              this.$message.success('操作成功');
              this.form = {
                plan_id: 0,
                title: '',
                budget: '',
                start_time: '',
                end_time_type: 0,
                end_time: '',
                purpose: '1',
                status: '1',
                checkboxGroup1: [],
                city: []
              };
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped="">
  .action-lists {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    background: #F7F8F8;
    .display {
      display: flex;
      align-items: center;
      height: 50px;
    }
    .left-btns {
      .display;
      div {
        width: 140px;
        height: 100%;
        line-height: 50px;
        text-align: center;
        color: #0056AF;
        cursor: pointer;
      }
      .selected {
        color: #166D9F;
        background: #fff;
      }
    }
    .right-action {
      .display;
      div {
        width: 34px;
        height: 34px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .table {
    width: calc(100% - 40px);
    padding: 20px;
    .make {
      padding: 20px 0;
    }
  }
  .page-c {
    background: #fff;
    padding: 20px;
  }
  img {
    width: 100%;
    height: 100%;
  }
</style>
